import { CheckCircle2, CreditCard, FlaskConical, Landmark, Wallet } from "lucide-react";
import { useT } from "@/lib/i18n";

const ICONS = { midtrans: Landmark, xendit: Wallet, stripe: CreditCard, demo: FlaskConical };

export default function PaymentMethods({ methods, value, onChange }) {
  const t = useT();
  return (
    <div className="grid gap-3" data-testid="payment-methods">
      {methods.map((m) => {
        const Icon = ICONS[m.id];
        const sel = value === m.id;
        return (
          <button type="button" key={m.id} disabled={!m.active} data-testid={`payment-option-${m.id}`} onClick={() => onChange(m.id)}
            className={`flex items-center gap-4 rounded-xl border-2 p-4 text-left transition-colors ${sel ? "border-[#5392F9] bg-blue-50/60" : "border-slate-200 bg-white hover:border-slate-300"} disabled:cursor-not-allowed disabled:opacity-55`}>
            <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${sel ? "bg-[#5392F9] text-white" : "bg-slate-100 text-slate-600"}`}>
              <Icon className="h-5 w-5" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-2 font-heading font-bold text-slate-900">
                {t(m.name)}
                {!m.active && <span className="rounded bg-slate-200 px-1.5 py-0.5 text-[10px] font-semibold uppercase text-slate-600">{t("Belum aktif")}</span>}
                {m.id === "demo" && m.active && <span className="rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase text-amber-700">Demo</span>}
              </span>
              <span className="block text-sm text-slate-500">{t(m.desc)}</span>
            </span>
            {sel && <CheckCircle2 className="h-5 w-5 text-[#5392F9]" />}
          </button>
        );
      })}
    </div>
  );
}
